import { render, staticRenderFns } from "./WalletConnector.vue?vue&type=template&id=123f45f0&scoped=true"
import script from "./WalletConnector.vue?vue&type=script&lang=js"
export * from "./WalletConnector.vue?vue&type=script&lang=js"
import style0 from "./WalletConnector.vue?vue&type=style&index=0&id=123f45f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123f45f0",
  null
  
)

export default component.exports